import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoayodhyacab() {



    const cardData = {





keyword: "Mumbai to Ayodhya Cab",

headingDescription: "Shreesha Tours & Travels offers comfortable and reliable Mumbai to Ayodhya Cab Service for pilgrimage tours, family trips, religious journeys, corporate travel, one-way cab booking, round trips, and long-distance road travel. Our chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options provide a safe and convenient travel experience from Mumbai to Ayodhya. With experienced drivers, well-maintained vehicles, transparent pricing, flexible travel plans, doorstep pickup, and 24/7 customer support, we ensure a smooth and hassle-free journey. Whether you are visiting Ayodhya for Ram Mandir Darshan, family travel, spiritual tourism, or personal requirements, Shreesha Tours & Travels provides dependable transportation with complete comfort and convenience for your long-distance journey.",

topPlaces: [
  {
    title: "Ram Mandir Ayodhya",
    description: "Ram Mandir is one of India's most important religious destinations, attracting devotees from across the country. Visitors can experience spiritual surroundings, grand architecture, and peaceful temple darshan."
  },
  {
    title: "Hanuman Garhi Ayodhya",
    description: "Hanuman Garhi is a famous temple dedicated to Lord Hanuman, located in the heart of Ayodhya. It is one of the most visited religious places by pilgrims coming to the city."
  },
  {
    title: "Kanak Bhawan Ayodhya",
    description: "Kanak Bhawan is a beautiful historic temple dedicated to Lord Ram and Goddess Sita, known for its artistic architecture, peaceful atmosphere, and religious importance."
  },
  {
    title: "Saryu River Ayodhya",
    description: "Saryu River is a sacred river in Ayodhya, famous for evening aarti, peaceful ghats, and spiritual experiences. It is a must-visit place for devotees and tourists."
  },
  {
    title: "Nageshwarnath Temple Ayodhya",
    description: "Nageshwarnath Temple is an ancient Shiva temple with great religious significance. It is an important attraction for pilgrims exploring Ayodhya's spiritual heritage."
  },
  {
    title: "Guptar Ghat Ayodhya",
    description: "Guptar Ghat is a peaceful riverside location known for beautiful views, religious significance, and relaxing surroundings along the Saryu River."
  },
  {
    title: "Ayodhya Ram Katha Park",
    description: "Ram Katha Park is a cultural attraction featuring beautiful gardens, events, and spiritual programs. It is a popular place for families and visitors."
  },
  {
    title: "Chitrakoot",
    description: "Chitrakoot is a famous pilgrimage destination near Ayodhya, known for Ram Ghat, Kamadgiri Temple, and places connected with Lord Ram's exile period."
  },
  {
    title: "Prayagraj",
    description: "Prayagraj is a major spiritual city famous for Triveni Sangam, Allahabad Fort, and religious events. Many travelers combine Ayodhya and Prayagraj pilgrimage tours."
  },
  {
    title: "Varanasi",
    description: "Varanasi is one of India's oldest spiritual cities, famous for Kashi Vishwanath Temple, Ganga Aarti, ghats, and rich cultural heritage. It is a popular addition to Ayodhya religious tours."
  }
],




"services": [
  {
    "name": "Mumbai to Ayodhya Cab",
    "description": "Book Mumbai to Ayodhya Cab for a comfortable and reliable long-distance journey with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cars for Ayodhya pilgrimage tours, family trips, religious journeys, and interstate travel with flexible one way and round trip options."
  },
  {
    "name": "Mumbai to Ayodhya Taxi",
    "description": "Choose Mumbai to Ayodhya Taxi for safe and convenient road travel with experienced drivers and spacious vehicles. Enjoy a smooth journey from Mumbai to Ayodhya with affordable fares, comfortable seating, doorstep pickup, and reliable transportation services."
  },
  {
    "name": "Mumbai to Ayodhya Cab Service",
    "description": "Book Mumbai to Ayodhya Cab Service for hassle-free religious and family travel with professional chauffeurs and premium vehicles. Our taxi services provide comfortable transportation for Ram Mandir Darshan, pilgrimage tours, family vacations, and long-distance journeys."
  },
  {
    "name": "Mumbai to Ayodhya Taxi Service",
    "description": "Hire Mumbai to Ayodhya Taxi Service for dependable interstate travel with clean AC cars and trained drivers. Get reliable cab solutions for religious trips, family tours, corporate travel, and personal journeys with flexible booking plans."
  },
  {
    "name": "Mumbai to Ayodhya Cab Booking",
    "description": "Complete Mumbai to Ayodhya Cab Booking with easy reservations, quick confirmation, and multiple vehicle options. Select the right car according to your group size and travel needs for a comfortable journey from Mumbai to Ayodhya."
  },
  {
    "name": "Mumbai to Ayodhya Car Rental",
    "description": "Choose Mumbai to Ayodhya Car Rental for chauffeur-driven vehicles designed for long-distance travel. Enjoy spacious cars, professional drivers, flexible schedules, and affordable rental packages for pilgrimage, family, and personal trips."
  },
  {
    "name": "Mumbai to Ayodhya Taxi Fare",
    "description": "Get Mumbai to Ayodhya Taxi Fare details with transparent pricing and affordable travel packages. Enjoy comfortable cab services with no hidden charges, experienced chauffeurs, and vehicle options suitable for individuals, families, and groups."
  },
  {
    "name": "Mumbai to Ayodhya One Way Cab",
    "description": "Book Mumbai to Ayodhya One Way Cab for convenient drop taxi service without return fare charges. Travel comfortably with professional drivers, clean vehicles, and flexible pickup locations for a smooth one-way journey."
  },
  {
    "name": "Mumbai to Ayodhya Round Trip Taxi",
    "description": "Reserve Mumbai to Ayodhya Round Trip Taxi for complete return travel solutions with flexible schedules and comfortable vehicles. Ideal for religious tours, family vacations, sightseeing, and extended stays in Ayodhya."
  },
  {
    "name": "Mumbai to Ayodhya Outstation Cab",
    "description": "Book Mumbai to Ayodhya Outstation Cab for reliable interstate transportation with premium vehicles and experienced chauffeurs. Perfect for long-distance pilgrimage travel, family trips, and private journeys with safe and comfortable road travel."
  },
  {
    "name": "Mumbai Airport to Ayodhya Cab",
    "description": "Choose Mumbai Airport to Ayodhya Cab for convenient airport pickup and drop services to Ayodhya. Enjoy timely transfers, luggage-friendly vehicles, professional drivers, and comfortable travel from Mumbai Airport to your destination."
  },
  {
    "name": "Mumbai to Ayodhya Private Taxi",
    "description": "Hire Mumbai to Ayodhya Private Taxi for personalized travel with a dedicated vehicle and professional chauffeur. Enjoy privacy, comfort, flexible routes, and a peaceful journey for religious and family travel."
  },
  {
    "name": "Mumbai to Ayodhya Innova Cab",
    "description": "Book Mumbai to Ayodhya Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Ideal for families and groups planning a long-distance pilgrimage or vacation journey."
  },
  {
    "name": "Mumbai to Ayodhya Innova Crysta Cab",
    "description": "Choose Mumbai to Ayodhya Innova Crysta Cab for luxury and comfortable interstate travel. Experience premium interiors, smooth rides, experienced chauffeurs, and enhanced comfort for family tours and religious trips."
  },
  {
    "name": "Mumbai to Ayodhya Ertiga Cab",
    "description": "Reserve Mumbai to Ayodhya Ertiga Cab for affordable group travel with spacious seating and comfortable interiors. Suitable for families, small groups, and pilgrimage travelers looking for economical long-distance transportation."
  },
  {
    "name": "Mumbai to Ayodhya Family Trip Cab",
    "description": "Book Mumbai to Ayodhya Family Trip Cab for safe and convenient family journeys with spacious vehicles and experienced drivers. Enjoy comfortable travel for vacations, religious visits, and special family occasions."
  },
  {
    "name": "Mumbai to Ayodhya Religious Tour Cab",
    "description": "Choose Mumbai to Ayodhya Religious Tour Cab for a peaceful pilgrimage journey with reliable transportation and professional chauffeurs. Travel comfortably for Ram Mandir Darshan, temple visits, and spiritual tours with family and groups."
  },
  {
    "name": "Best Mumbai to Ayodhya Cab Booking",
    "description": "Book the Best Mumbai to Ayodhya Cab Booking service for safe, comfortable, and reliable travel with premium vehicles, trained chauffeurs, and affordable packages. Enjoy a smooth pilgrimage journey from Mumbai to Ayodhya with flexible one way and round trip options."
  }
],
"tableData": [
  ["Mumbai to Ayodhya Cab", "Mumbai to Ayodhya Taxi"],
  ["Mumbai to Ayodhya Cab Service", "Mumbai to Ayodhya Taxi Service"],
  ["Mumbai to Ayodhya Cab Booking", "Mumbai to Ayodhya Car Rental"],
  ["Mumbai to Ayodhya Taxi Fare", "Mumbai to Ayodhya One Way Cab"],
  ["Mumbai to Ayodhya Round Trip Taxi", "Mumbai to Ayodhya Outstation Cab"],
  ["Mumbai Airport to Ayodhya Cab", "Mumbai to Ayodhya Private Taxi"],
  ["Mumbai to Ayodhya Innova Cab", "Mumbai to Ayodhya Innova Crysta Cab"],
  ["Mumbai to Ayodhya Ertiga Cab", "Mumbai to Ayodhya Family Trip Cab"],
  ["Mumbai to Ayodhya Religious Tour Cab", "Best Mumbai to Ayodhya Cab Booking"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Ayodhya Cab Service",
    WhyChoosedescription: "Shreesha Travels offers reliable Mumbai to Ayodhya cab services for devotees, families, tourists, and travellers looking for a comfortable long-distance road journey. Enjoy a safe and convenient ride with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Convenient Travel to Ayodhya Ram Mandir",
    WhyChoosedescription: "Plan your spiritual journey from Mumbai to Ayodhya with flexible cab options that allow you to travel at your own pace, include sightseeing stops, and enjoy a hassle-free pilgrimage experience."
  },
  {
    WhyChooseheading: "Multiple Car Options for Long Distance Travel",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles depending on your family size, luggage, and comfort preferences."
  },
  {
    WhyChooseheading: "Ideal for Pilgrimage & Family Tours",
    WhyChoosedescription: "Our Mumbai to Ayodhya taxis are suitable for temple visits, religious tours, family vacations, senior citizen travel, group journeys, and customized North India tour plans."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "Select a direct one-way cab to Ayodhya or choose a round-trip package with return travel, additional sightseeing, and multi-day travel arrangements according to your schedule."
  },
  {
    WhyChooseheading: "Experienced Drivers for Interstate Routes",
    WhyChoosedescription: "Our professional chauffeurs have experience with long-distance highway travel and ensure safe driving, timely service, and comfortable journeys throughout the Mumbai to Ayodhya route."
  },
  {
    WhyChooseheading: "Well-Maintained Vehicles for Spiritual Journeys",
    WhyChoosedescription: "Every cab is cleaned, serviced, air-conditioned, and inspected before departure to provide a peaceful and comfortable travel experience for passengers."
  },
  {
    WhyChooseheading: "Book Mumbai to Ayodhya Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, customized travel solutions, professional driver assistance, and reliable cab service for your Mumbai to Ayodhya pilgrimage or personal journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Ayodhya cab for a pilgrimage trip?",
    answer: "Yes, we provide comfortable cab services from Mumbai to Ayodhya for Ram Mandir visits, religious tours, family trips, and spiritual journeys."
  },
  {
    question: "Is Mumbai to Ayodhya one-way cab service available?",
    answer: "Yes, one-way cab bookings are available for passengers who need direct travel from Mumbai to Ayodhya."
  },
  {
    question: "Which vehicles are suitable for Mumbai to Ayodhya travel?",
    answer: "Sedan cars are suitable for small groups, while Ertiga, Kia Carens, Innova, Innova Crysta, and SUVs are recommended for families with more passengers and luggage."
  },
  {
    question: "How many days are required for Mumbai to Ayodhya cab travel?",
    answer: "The travel duration depends on the selected route, stops, traffic conditions, and your sightseeing requirements."
  },
  {
    question: "Can senior citizens travel comfortably by cab to Ayodhya?",
    answer: "Yes, comfortable vehicles with experienced drivers make long-distance travel convenient for senior citizens and families."
  },
  {
    question: "Can I include other religious destinations with Ayodhya?",
    answer: "Yes, customized itineraries can include additional destinations, sightseeing places, and pilgrimage locations as per your travel plan."
  },
  {
    question: "Do you provide round-trip Mumbai to Ayodhya taxi booking?",
    answer: "Yes, round-trip packages are available with flexible return schedules and customized travel plans."
  },
  {
    question: "How is the Mumbai to Ayodhya cab fare calculated?",
    answer: "The fare depends on the vehicle type, travel distance, number of travel days, route, driver allowance, and additional requirements."
  },
  {
    question: "Can I book an overnight Mumbai to Ayodhya cab journey?",
    answer: "Yes, overnight travel arrangements can be planned according to your preferred departure time and itinerary."
  },
  {
    question: "How can I book Mumbai to Ayodhya Cab with Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger details, preferred vehicle, and trip plan to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vinay Deshmukh",
    feedback: "Our Mumbai to Ayodhya journey was arranged perfectly. The vehicle was comfortable, the driver was experienced, and the complete trip was peaceful and well-managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback: "The long-distance pilgrimage journey became easy with Shreesha Travels. Clean car, helpful driver, and excellent coordination made our family trip memorable.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ayodhya Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-ayodhya-cab.webp",
  "description":
    "Book Mumbai to Ayodhya Cab with Shreesha Tours & Travels for safe, comfortable, and affordable long-distance taxi services. We provide one-way and round-trip cabs from Mumbai to Ayodhya with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for pilgrimage tours, family trips, business travel, airport transfers, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-ayodhya-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Mumbai to Ayodhya Cab | One Way & Round Trip Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Ayodhya Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Ayodhya pilgrimage, family trips, and long-distance travel with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Ayodhya Cab, Mumbai to Ayodhya Taxi, Mumbai to Ayodhya Cab Service, Mumbai to Ayodhya Taxi Service, Mumbai to Ayodhya Cab Booking, Mumbai to Ayodhya Car Rental, Mumbai to Ayodhya Taxi Fare, Mumbai to Ayodhya One Way Cab, Mumbai to Ayodhya Round Trip Taxi, Mumbai to Ayodhya Outstation Cab, Mumbai Airport to Ayodhya Cab, Mumbai Ayodhya Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoayodhyacab;